import React from "react";

const categoryRoutes = [
  {
    path: "/suggestions",
    component: React.lazy(() => import("./index")),
  },
];
export default categoryRoutes;
